import React from 'react';
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Image,
  Center,
  Divider,
  Text,
} from '@chakra-ui/react';
import ProjectItem from '../projectItem';
import 'react-awesome-slider/dist/styles.css';
import '../styles/spec-list.css';
import { RiComputerLine } from 'react-icons/ri';

const TOOL_GROUPS = [
  {
    title: 'Computer Vision',
    items: [
      ['Object Detection', 'YOLOv4'],
      ['Identification', 'Shirt-colour classification'],
    ],
  },
  {
    title: 'Input & Output',
    items: [
      ['Source Footage', 'CCTV video'],
      ['Result', 'Annotated video with labelled bounding boxes'],
    ],
  },
];

export default function Project1() {
  const title = 'Individual and Object Detection from CCTV';
  const subtitle = 'Graduation Project, 2020 - 2021';
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div>
      <div className="card-container" onClick={onOpen}>
        <ProjectItem
          title={title}
          subtitle={subtitle}
          tags={['YOLOv4', 'Computer Vision']}
        />
      </div>

      <Modal
        onClose={onClose}
        size={{ base: 'full', lg: '4xl' }}
        isOpen={isOpen}
        scrollBehavior={'inside'}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader pb={4}>
            {title}
            <Box className="eyebrow" mt={1}>
              {subtitle}
            </Box>
            <Divider mt={4} />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box className="eyebrow" mb={3}>
              OVERVIEW
            </Box>
            <Box>
              <Text className="modal-copy">
                A computer-vision system that finds people in CCTV footage and
                picks them out by the colour of the shirt they are wearing.
                Someone reviewing a recording describes the clothing they are
                looking for, and the system returns the moments where a matching
                person appears.
              </Text>
            </Box>
            <Box mt={6}>
              <Text className="modal-copy">
                YOLOv4 detects every person in the frame, then a colour
                classification step reads the dominant colour of each detected
                person&apos;s clothing and keeps only the ones that match the
                query. The output is the original footage with matching people
                boxed and labelled — turning a manual scrub through hours of
                video into a targeted search.
              </Text>
            </Box>

            <Box className="eyebrow" mt={12} mb={4}>
              RESULT
            </Box>
            <figure className="modal-figure">
              <Image
                className="modal-figure__media"
                src="/projects/cctv.gif"
                alt="People detected in CCTV footage, boxed and labelled by shirt colour"
              />
              <figcaption className="modal-figure__caption">
                Detected people boxed and labelled by shirt colour, drawn back
                onto the source footage.
              </figcaption>
            </figure>

            <Box className="eyebrow" mt={12} mb={6}>
              TOOLS
            </Box>
            <div className="spec-grid">
              {TOOL_GROUPS.map(group => (
                <div className="spec-group" key={group.title}>
                  <div className="spec-group__title">{group.title}</div>
                  <dl className="spec-list">
                    {group.items.map(([label, value]) => (
                      <div className="spec-row" key={label}>
                        <dt className="spec-row__label">{label}</dt>
                        <dd className="spec-row__value">{value}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              ))}
            </div>

            <Box className="eyebrow" mt={12} mb={3}>
              PROJECT PERIOD
            </Box>
            <Box mt={3} fontFamily="mono" fontSize={13}>
              2020 — 2021
            </Box>

            <Center mt={12}>
              <Divider mr={5} />
              <RiComputerLine size={50} />
              <Divider ml={5} />
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
